import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=5db0882e&"
import script from "./Followers.vue?vue&type=script&lang=js&"
export * from "./Followers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports